var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Cookies from 'js-cookie';
import { action, computed, makeObservable, observable } from 'mobx';
import nestedProperty from 'nested-property';
import { SingleConcurrentRequestController } from '../../common';
import { getParamSerializerForAxiosVersion1or0 } from '../../common/util/ApiUtil';
export default class CartStore {
    constructor(rootStore, props) {
        Object.defineProperty(this, "cartNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isVatDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cartItemsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "cart", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SingleConcurrentRequestController()
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                timeout: 30000,
                paramsSerializer: getParamSerializerForAxiosVersion1or0(),
                withCredentials: true
            }
        });
        Object.defineProperty(this, "urlData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "updateCartContents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (cartItemsCount) => {
                this.setCartItemsCount(cartItemsCount);
                this.getCart(false);
            }
        });
        Object.defineProperty(this, "setCartItemsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (cartItemsCount) => {
                this.cartItemsCount = cartItemsCount;
            }
        });
        Object.defineProperty(this, "getCart", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (changeStatus = true) => {
                if (changeStatus) {
                    this.status = 'FETCHING';
                }
                try {
                    this.cart = await this.controller.get(`${this.urlData.shopBaseURL}/api/cart`, this.config);
                    this.updateCartItemsCount();
                    this.status = 'FETCHED';
                }
                catch (_e) {
                    this.status = 'ERROR';
                }
            }
        });
        Object.defineProperty(this, "removeProduct", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (productId) => {
                return this.removeCartItem(productId, 'product');
            }
        });
        Object.defineProperty(this, "removeService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (serviceId) => {
                return this.removeCartItem(serviceId, 'service');
            }
        });
        Object.defineProperty(this, "setCartNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (cartNotice) => {
                const { sectionStore } = this.rootStore;
                this.hideCartNotice();
                let cartUpdatedDuringSetSection = false;
                if (cartNotice === null || cartNotice === void 0 ? void 0 : cartNotice.showNotice) {
                    if (sectionStore.section !== 'cart') {
                        sectionStore.setSection('cart');
                        cartUpdatedDuringSetSection = true;
                    }
                }
                if ((cartNotice === null || cartNotice === void 0 ? void 0 : cartNotice.updateCart) && !cartUpdatedDuringSetSection) {
                    this.getCart();
                }
                this.cartNotice = cartNotice;
            }
        });
        Object.defineProperty(this, "getProductUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => {
                if (this.rootStore.environmentStore.app === 'shop') {
                    return path;
                }
                return `${this.urlData.shopBaseURL}${path}`;
            }
        });
        Object.defineProperty(this, "removeCartItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (id, type) => {
                try {
                    this.cart = (await this.controller.delete(`${this.urlData.shopBaseURL}/api/cart/${type}/${id}`, {
                        ...this.config,
                        params: { lang: this.rootStore.environmentStore.lang }
                    })).data;
                    this.updateCartItemsCount();
                    this.hideCartNotice();
                }
                catch (_e) {
                    this.showRemoveErrorNotice();
                }
            }
        });
        Object.defineProperty(this, "hideCartNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                if ((_a = this.cartNotice) === null || _a === void 0 ? void 0 : _a.timeout) {
                    clearTimeout(this.cartNotice.timeout);
                }
                this.cartNotice = {
                    ...this.cartNotice,
                    showNotice: false,
                    timeout: null
                };
            }
        });
        Object.defineProperty(this, "showRemoveErrorNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setCartNotice({
                    showNotice: true,
                    type: 'error',
                    timeout: setTimeout(() => this.hideCartNotice(), 10000),
                    messageKey: 'cart.remove.error'
                });
            }
        });
        Object.defineProperty(this, "updateCartItemsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const shoppingCartItems = parseInt(Cookies.get('shoppingCartIcon'), 10);
                this.setCartItemsCount(!isNaN(shoppingCartItems) ? shoppingCartItems : 0);
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.urlData = rootStore.environmentStore.URLData;
        if (!nestedProperty.get(window, 'telia.megamenu.setShoppingCartSize')) {
            nestedProperty.set(window, 'telia.megamenu.setShoppingCartSize', this.updateCartContents);
        }
        if (props === null || props === void 0 ? void 0 : props.shoppingCartItems) {
            this.setCartItemsCount(props.shoppingCartItems);
        }
        else {
            this.updateCartItemsCount();
        }
    }
    get fetching() {
        return ['UNINITIALIZED', 'FETCHING'].includes(this.status);
    }
    get fetched() {
        return this.status === 'FETCHED';
    }
    get error() {
        return this.status === 'ERROR';
    }
    get products() {
        var _a;
        return ((_a = this.cart) === null || _a === void 0 ? void 0 : _a.products) || [];
    }
    get services() {
        var _a;
        return ((_a = this.cart) === null || _a === void 0 ? void 0 : _a.services) || [];
    }
    get cartURL() {
        return `${this.urlData.shopBaseURL}/checkout`;
    }
}
__decorate([
    observable
], CartStore.prototype, "cartNotice", void 0);
__decorate([
    observable
], CartStore.prototype, "isVatDisabled", void 0);
__decorate([
    observable
], CartStore.prototype, "cartItemsCount", void 0);
__decorate([
    observable
], CartStore.prototype, "cart", void 0);
__decorate([
    observable
], CartStore.prototype, "status", void 0);
__decorate([
    action
], CartStore.prototype, "updateCartContents", void 0);
__decorate([
    action
], CartStore.prototype, "setCartItemsCount", void 0);
__decorate([
    action
], CartStore.prototype, "getCart", void 0);
__decorate([
    action
], CartStore.prototype, "removeProduct", void 0);
__decorate([
    action
], CartStore.prototype, "removeService", void 0);
__decorate([
    action
], CartStore.prototype, "setCartNotice", void 0);
__decorate([
    computed
], CartStore.prototype, "fetching", null);
__decorate([
    computed
], CartStore.prototype, "fetched", null);
__decorate([
    computed
], CartStore.prototype, "error", null);
__decorate([
    computed
], CartStore.prototype, "products", null);
__decorate([
    computed
], CartStore.prototype, "services", null);
//# sourceMappingURL=CartStore.js.map